import React from 'react';
import { useTranslation } from 'react-i18next';

import { CustomFieldType } from '~/types/api.graphql';

import { KeptColumnName, SavedAsDetail } from './CustomFieldsField.styles';

interface KeptColumnLineProps {
  columnName: string;
  savedName: string;
  fieldType: CustomFieldType;
}

/** One kept column, "age as age (Integer)", the same on the card and in the form's collapsed header. */
const KeptColumnLine = ({ columnName, savedName, fieldType }: KeptColumnLineProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div>
      <KeptColumnName>{columnName}</KeptColumnName>{' '}
      <SavedAsDetail>
        {/* A saved name being edited may hold any text; React escapes it, so i18next mustn't as well */}
        {t('aiInsights.a2ui.customFields.savedAsWithType', {
          savedName,
          fieldType,
          interpolation: { escapeValue: false },
        })}
      </SavedAsDetail>
    </div>
  );
};

export default KeptColumnLine;
